export const testModel = {
  covidTestDone: { value: '', error: '', isRequired: true },
  lastTestResult: { value: '', error: '', isRequired: true },
  isValid: true,
  isCompleted: false,
  triedToContinue: false,
}
